import { render, staticRenderFns } from "./TeachingTemplate.vue?vue&type=template&id=00c1d243&scoped=true"
import script from "./TeachingTemplate.vue?vue&type=script&lang=js"
export * from "./TeachingTemplate.vue?vue&type=script&lang=js"
import style0 from "./TeachingTemplate.vue?vue&type=style&index=0&id=00c1d243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1d243",
  null
  
)

export default component.exports